import { usePlatform } from "@platform/PlatformContext";
import makeTimezoneOptionFromTzdbTimezone from "@platform/features/timezones/utils/makeTimezoneOptionFromTzdbTimezone";
import { getTimeZones, TimeZone } from "@vvo/tzdb";

export const useUserTimezoneOption = () => {
  const { user } = usePlatform();

  const timezones = getTimeZones({ includeUtc: true });

  const foundTimezone = timezones.find((z) => {
    const isUtcGroup = z.name === "Etc/UTC" || z.group.includes("Etc/UTC");

    const value = isUtcGroup ? "UTC" : z.name;

    return value === user?.timezone;
  });

  if (!foundTimezone) {
    return null;
  }

  return makeTimezoneOptionFromTzdbTimezone(foundTimezone as TimeZone);
};

export default useUserTimezoneOption;
